import { Popover, Tooltip } from 'antd';
import { DateTime } from 'luxon';
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { COLOR_WEEKEND, FORMAT_DATE, MINIMAL_LENGTH_FOR_SHOWING_TEXT, STROKE_PARAM } from '../const';
import { ComponentsDispatch, RootState } from '../store';
import { setterGant } from '../store/slices/gantSlice';
import { GroupListOfTimePeriodType } from '../types';
import GantButtonListOfTask from './gantButtonListOfTask';
import { useScrollContext } from './scrollContext';

interface IGantGridCell {
    groupTimePeriod: GroupListOfTimePeriodType;
    currentStartIndex: number;
    heightRow: number;
    height: number;
    isShowText?: boolean;
    lengthGroup: number;
    currentX: number;
    widthColumn: number;
    isSmallSizeLabel: boolean;
}

const GantGridCell: React.FC<IGantGridCell> = ({
    groupTimePeriod,
    currentStartIndex,
    heightRow,
    height,
    isShowText,
    lengthGroup,
    currentX,
    widthColumn,
    isSmallSizeLabel,
}) => {
    const dispatch = useDispatch<ComponentsDispatch>();
    const startDate = useSelector<RootState, string>((state) => state.gant.startDateExtend);
    const { isScrollingHeader } = useScrollContext();
    const xStart = currentStartIndex * widthColumn;
    const width = widthColumn * groupTimePeriod.length;
    const xEnd = xStart + width;

    const idClip = `clip${groupTimePeriod.key}`;

    const handleShowListTask = () => {
        const minDate = DateTime.fromSQL(startDate).plus({ days: currentStartIndex }).toFormat(FORMAT_DATE);
        const maxDate = DateTime.fromSQL(startDate)
            .plus({ days: currentStartIndex + groupTimePeriod.length - 1 })
            .toFormat(FORMAT_DATE);

        dispatch(
            setterGant({
                dayForListTaskShow: [minDate, maxDate],
                scheduleItemForListTaskShow: null,
            }),
        );
    };

    return (
        <g>
            <clipPath id={idClip}>
                <rect x={xStart} y={0} width={width} height={height} opacity={0.4} />
            </clipPath>
            {groupTimePeriod.isWeekend ? (
                <rect
                    x={xStart}
                    y={0}
                    width={width}
                    height={isShowText ? height : height}
                    fill={COLOR_WEEKEND}
                    opacity={0.4}
                />
            ) : (
                <g></g>
            )}
            <line x1={xEnd} y1={0} x2={xEnd} y2={height} {...STROKE_PARAM} />
            {isScrollingHeader && isShowText && lengthGroup > MINIMAL_LENGTH_FOR_SHOWING_TEXT && (
                <g>
                    <text
                        x={currentX}
                        y={heightRow / 2 + (isSmallSizeLabel ? 4 : 6)}
                        fill="black"
                        textAnchor="middle"
                        clipPath={`url(#${idClip})`}
                        fontSize={isSmallSizeLabel ? 10 : 13}
                    >
                        {groupTimePeriod.label}
                    </text>
                </g>
            )}
            {!isScrollingHeader && isShowText && lengthGroup > MINIMAL_LENGTH_FOR_SHOWING_TEXT && (
                <Tooltip title={groupTimePeriod.tip}>
                    <Popover content={<GantButtonListOfTask onClick={handleShowListTask} />} placement={'bottom'}>
                        <g>
                            <rect x={xStart} y={0} width={width} height={height} fill={'white'} opacity={0.04} />
                            <text
                                x={currentX}
                                y={heightRow / 2 + (isSmallSizeLabel ? 4 : 6)}
                                fill="black"
                                textAnchor="middle"
                                clipPath={`url(#${idClip})`}
                                fontSize={isSmallSizeLabel ? 10 : 13}
                            >
                                {groupTimePeriod.label}
                            </text>
                        </g>
                    </Popover>
                </Tooltip>
            )}
        </g>
    );
};

export default React.memo(GantGridCell);
